export const COA_SWITCH_RULE_FORM_FIELD_IDS = {
  CATEGORY: 'category'
};

export const ASSET_CATEGORIES_PARENT = 'asset';
export const LIABILITY_CATEGORIES_PARENT = 'liability';
